"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _KeyStore = require("crm_data/store/KeyStore");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _immutable = require("immutable");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _InteractionRecord = _interopRequireDefault(require("customer-data-objects/interaction/InteractionRecord"));

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _default = (0, _KeyStore.defineKeyStore)({
  namespace: _ActionNamespaces.VIDEO_CONFERENCE,
  getInitialState: function getInitialState() {
    return (0, _immutable.Map)({
      communicatorInteraction: new _InteractionRecord.default(),
      associatedContactIds: (0, _immutable.Set)()
    });
  },
  idIsValid: function idIsValid(id) {
    return typeof id === 'string';
  }
}).defineResponseTo(_ActionTypes.MEETING_DETAILS_UPDATED, function (state, interaction) {
  var interactionId = interaction.getIn(['engagement', 'id']); // differentiate timeline interactions from eachother/communicator interactions so that the conference plugin doesn't use information from the wrong meeting

  return state.set(interactionId ? "" + interactionId : 'communicatorInteraction', interaction);
}).defineResponseTo(_ActionTypes.ENGAGEMENT_ASSOCIATIONS_MERGE_AND_UPDATE, function (state, _ref) {
  var associationsMapToMerge = _ref.associationsMapToMerge;
  return state.set('associatedContactIds', associationsMapToMerge.get('contactIds'));
}).defineResponseTo(_ActionTypes.ENGAGEMENT_ASSOCIATIONS_UPDATE, function (state, _ref2) {
  var associatedIds = _ref2.associatedIds;
  return state.set('associatedContactIds', state.get('associatedContactIds').add(associatedIds));
}).defineResponseTo(_ActionTypes.ENGAGEMENT_ASSOCIATIONS_DELETE, function (state, _ref3) {
  var associatedId = _ref3.associatedId;
  return state.set('associatedContactIds', state.get('associatedContactIds').delete(associatedId));
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;